module.exports = __webpack_public_path__ + "img/img_tpdl.dc0d6e4b.webp";